import React from 'react'
import { postActusParams } from '../../../types'
import dayjs from 'dayjs'
import style from './style.module.scss'
import { useEditor } from '@smartfire/js-block-engine'
import clsx from 'clsx'
import he from 'he'

type mainTileProps = {
    post: postActusParams
}

export const MainTile: React.FC<mainTileProps> = ({ post }) => {
    const { isEditing } = useEditor()

    return (
        <div className={clsx(style.tile, isEditing ? style.admin : undefined)}>
            <a href={post.link} className={style.thumbnail}>
                {post.thumbnail.tag && (
                    <picture dangerouslySetInnerHTML={{ __html: post.thumbnail.tag }} />
                )}
            </a>
            <div className={style.content}>
                <div className={style.top}>
                    <div className={style.taxs}>
                        {post.parentTax && (
                            <a className={style.ptax} href={post.parentTax.link}>
                                {post.parentTax.name}
                            </a>
                        )}
                        {post.tax && post.parentTax && <span className={style.separator}>/</span>}
                        {post.tax && (
                            <a className={style.ctax} href={post.tax.link}>
                                {post.tax.name}
                            </a>
                        )}
                    </div>

                    <h2 className={style.title}>
                        <a href={post.link}>{post.title}</a>
                    </h2>
                    <div className={style.excerpt}>
                        <a href={post.link}>{he.decode(post.excerpt)}</a>
                    </div>
                </div>
                <div className={style.bottom}>
                    <p className={style.date}>{dayjs(post.date).format('DD MMM YYYY')}</p>
                    <p className={style.readingTime}>
                        <i className={'fi fi-rs-stopwatch'} />
                        {post.readingTime}
                        &nbsp;MIN.
                    </p>
                </div>
            </div>
        </div>
    )
}
